import React from 'react';
import { Breadcrumbs, Breadcrumb as BreadcrumbValue, BreadcrumbsProps } from '../../wag-react/components/Breadcrumbs';
import { BoxProps } from '../../wag-react/next-components/box';
export type ArticleBreadcrumbsValue = BreadcrumbValue[];
type Props = Omit<BoxProps, 'value'> & Omit<BreadcrumbsProps, 'list'> & {
  value: ArticleBreadcrumbsValue;
};
export const ArticleBreadcrumbs = ({
  value,
  ...rest
}: Props) => <Breadcrumbs fontSize="12px" variant="ul"
// @ts-expect-error - list prop is not in the type
list={value} my={['12px', '12px', 'unset']} {...rest} data-sentry-element="Breadcrumbs" data-sentry-component="ArticleBreadcrumbs" data-sentry-source-file="index.tsx" />;
export type ArticleBreadcrumbsProps = Props;